module.exports = __webpack_public_path__ + "img/lcc.30f26f5a.png";